export default {"src":"/_next/static/media/leap-wallet-extension.77eea9cf.svg","height":36,"width":36};